<div [formGroup]="form" class="form-group field" style="min-width: 200px">
  <p-float-label>
    <label for="fieldName?.toString() + groupName?.toString()"
      >{{ label ?? 'Items' }}
      @if (isRequired()) {
        <span style="color: red">*</span>
      }
    </label>
    <p-multiSelect
      #control
      aria-describedby="input-help"
      [formControlName]="fieldName ?? null"
      [options]="(items$ | async) ?? undefined"
      [readonly]="this.disabled"
      appendTo="body"
      [optionValue]="keyProperty"
      [optionLabel]="displayProperty"
      display="chip"
      [showHeader]="showToggleAll || searchOn"
      [showClear]="true"
      [group]="group"
      [filter]="searchOn"
      [showToggleAll]="showToggleAll"
      [overlayVisible]="overlayVisible"
      [placeholder]="placeholder"
      (onChange)="onChange($event)"
    >
      <ng-template let-group pTemplate="group">
        <div class="flex items-center" (click)="selectGroup(group.items)">
          @if (groupIcon) {
            <i [class]="groupIcon" class="mr-2"></i>
          }
          <span>{{ group[displayProperty] }}</span>
        </div>
      </ng-template>
    </p-multiSelect>
    <label for="control"
      >{{ label ?? 'Items' }}
      @if (isRequired()) {
        <span style="color: red">*</span>
      }
    </label>
    <ng-content></ng-content>
    @if (displayHint) {
      <small class="block" style="font-weight: normal">{{ displayHint }}</small>
    }
    <s-form-error-input
      [groupName]="groupName"
      [fieldName]="fieldName"
      [form]="form"
      [apiError]="apiError"
      [schema]="schema"
    />
  </p-float-label>
</div>
